import { render, staticRenderFns } from "./authoritative_pdf_review.vue?vue&type=template&id=78bf7108&scoped=true&"
import script from "./authoritative_pdf_review.vue?vue&type=script&lang=js&"
export * from "./authoritative_pdf_review.vue?vue&type=script&lang=js&"
import style0 from "./authoritative_pdf_review.vue?vue&type=style&index=0&id=78bf7108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf7108",
  null
  
)

export default component.exports